import { useState, useEffect } from 'react';
import { Box, Stack, Typography, useTheme, TablePagination, Button, IconButton } from '@mui/material';
import React from 'react';
import Datatable from '../../../components/DataTable';
import TablePaginationActions from '../../../components/TablePaginationActions';
import PageHeader from '../../../components/PageHeader';
import { useSelector } from 'react-redux';
import { CancelToken } from 'apisauce';
import appapi from '../../../api/apiClient';
import TraderClientDetails from './components/TraderClientDetails';
import moment from 'moment';
import SendReport from './components/SendReport';
import { checkPermission } from '../../../redux/features/authSlice';
import { useTranslation } from 'react-i18next';
import AccessDenied from '../AccesDenied/AccessDenied';

const companyType = [
  {
    id: 'ship owner',
    name: 'Ship Owner',
  },
  {
    id: 'ship manager',
    name: 'Ship Manager',
  },
  {
    id: 'operator',
    name: 'Operator',
  },
  {
    id: 'charterer',
    name: 'Charterer',
  },
];

const screeningStatus = {
  pending: '#BA9B1D1A',
  approved: '#00A63226',
  rejected: '#C220201A',
  inprogress: '#006DFF1A',
  pendingColor: '#BA9B1D',
  approvedColor: '#00A632',
  rejectedColor: '#C22020',
  inprogressColor: '#006DFF',
};

export default function TraderClientManagement() {
  const theme = useTheme();
  const [search, setSearch] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [filter1, setFilter1] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedData, setSelectedData] = useState(null);
  const [openSendReport, setOpenSendReport] = useState(false);
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    field: '_id',
    sortOrder: 'desc',
    companyTypeFilter: '',
  });

  const { user } = useSelector((state) => state.auth);
  const {t} = useTranslation()

  const clientPermission = useSelector((state) => checkPermission(state, 'Client Management', 'Manage Reports'));
  const clientKYCPermission = useSelector((state) => checkPermission(state, 'Client Management', 'Manage KYC'));

  let source = CancelToken.source();
  const text = theme.palette.primary.text;

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
      default: true,
      columnEditable: false,
      activeColumn: true,
    },
    {
      id: 1,
      header: 'Display name',
      accessor: 'displayName',
      width: '25%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 2,
      header: 'Legal Entity',
      accessor: 'entityType',
      width: '10%',
      default: true,
      columnEditable: false,
      activeColumn: true,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 3,
      header: 'Client type',
      accessor: 'companyType',
      width: '15%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'checkbox',
        typeFilter: true,
        filterList:
          companyType?.map((item) => {
            return {
              label: item?.name,
              value: item?.id,
            };
          }) || [],
      },
    },
    {
      id: 4,
      header: 'Date',
      accessor: 'createdOn',
      width: '20%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
    },
    {
      id: 5,
      header: 'Status',
      accessor: 'screeningStatus',
      width: '10%',
      default: true,
      columnEditable: true,
      activeColumn: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [],
      },
      jcc: true,
      Cell: (item) => (
        <div className="flex !justify-center">
          <Stack
            justifyContent={'center'}
            alignItems={'center'}
            className="fw-regular fs-12 ff-Roboto h-[28px] w-[100px] px-[10px] rounded-[16px] capitalize"
            sx={{ backgroundColor: screeningStatus[item?.screeningStatus], color: screeningStatus[`${item?.screeningStatus}Color`] }}
          >
            {item?.screeningStatus === 'inprogress' ? t('In progress') : t(item?.screeningStatus) || '-'}
          </Stack>
        </div>
      ),
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1, filter: search }));
  };

  const handleGetCompany = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/client-management/allRequestsForTrader/${user?.companyId}`,
      {
        pageNumber: payload.page,
        filter: payload.filter || null,
        pageSize: payload.limit,
        field: payload.field === 'displayName' ? 'sortDisplayName' : payload.field === 'name' ? 'sortName' : payload.field,
        sortOrder: payload.sortOrder,
        companyTypeFilter: payload.companyTypeFilter,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          item.createdOn = moment(item.createdOn).format('DD-MM-YYYY');
          item.isSelected = false;
          return item;
        });
        setCompanyList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.response?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setCompanyList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setCompanyList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    if((clientKYCPermission.viewAccess || clientPermission.viewAccess)) {
      handleGetCompany();
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.field, payload.sortOrder, payload.companyTypeFilter, clientKYCPermission.viewAccess, clientPermission.viewAccess]);

  const selectRow = (sitem, sindex) => {
    const contacts = companyList.map((item, index) => {
      item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
      item.selected = item._id === sitem._id;
      return item;
    });
    setSelectedData(sitem);
    setCompanyList(contacts);
    setIsDrawerOpen(true);
  };

  const handleExcelDownload = async (format) => {
    const response = await appapi.get(
      `/client-management/excelAllRequestsForTrader/${user.companyId}`,
      {
        filter: payload.filter || null,
        companyTypeFilter: payload.companyTypeFilter,
        field: payload.field === 'displayName' ? 'sortDisplayName' : payload.field === 'name' ? 'sortName' : payload.field,
        sortOrder: payload.sortOrder,
        companyId: user?.companyId,
        format,
      },
      { observe: 'response', responseType: 'blob' },
    );
    if (response.ok) {
      try {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        const ext = format === 'csv' ? 'csv' : 'xlsx';
        link.download = `CLIENT${new Date().getTime()}.${ext}`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error downloading:', error);
      }
    } else {
    }
  };

  useEffect(() => {
    if (selectedCompanyIds.length > 0) {
      const items = companyList.map((res) => {
        return {
          ...res,
          isSelected: selectedCompanyIds.includes(res.companyId),
        };
      });
      setCompanyList(items);
    } else {
      const items = companyList.map((res) => {
        return {
          ...res,
          isSelected: false,
        };
      });
      setCompanyList(items);
    }
  }, [selectedCompanyIds]);

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    const ids = [...selectedCompanyIds];
    if (checkedStatus) {
      ids.push(item.companyId);
    } else {
      const index = ids.indexOf(item.companyId);
      if (index != -1) {
        ids.splice(index, 1);
      }
    }
    setSelectedCompanyIds(ids);
  };

  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  return (
   (clientKYCPermission.viewAccess || clientPermission.viewAccess) ? <Stack
      flex={1}
      direction={'row'}
      className="m-[8px] rounded-[8px] bg-white"
    >
      <Stack flex={1}>
        <PageHeader
          handleFilterButton={true}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
          showExport={payload.totalLength > 0 ? true : false}
          onExport={(type) => {
            handleExcelDownload(type);
          }}
          columnPreference={payload.totalLength > 0 ? true : false}
          columns={customerManagementColumn}
          applyColumnPreference={(c) => setCustomerManagementColumn(c)}
          onRefresh={() => {
            if (payload.page === 1) {
              handleGetCompany();
            } else {
              setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1 }));
            }
          }}
        >
          <Stack
            direction="row"
            flex={1}
          >
            <Stack flexGrow={1} />
            {clientPermission.addAccess &&  (
              <Button
                sx={{
                  color: theme.palette.primary.main,
                  textTransform: 'uppercase',
                  '&:disabled': {
                    color: 'rgba(0, 51, 153,0.5)',
                  },
                }}
                className="fs-14 ff-Roboto fw-medium !mr-[20px]"
                onClick={() => setOpenSendReport(true)}
                variant="text"
                disabled={selectedCompanyIds.length === 0}
              >
                {t('Send report')}
              </Button>
            )}
          </Stack>
        </PageHeader>
        <Stack
          flexGrow={1}
          className="relative flex-auto overflow-auto h-0"
        >
          <Datatable
             tableHeadBgColor={'#e2eeff'}
            columns={customerManagementColumn.filter((res) => res.activeColumn)}
            data={companyList || []}
            isLoading={isLoading}
            onClickRow={(item, index) => {
              selectRow(item, index);
            }}
            onChangeFilter={(filterValues) => {
              const sortValues = filterValues?.sort;
              let columnUpdate = customerManagementColumn;
              columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
              if (filterValues.accessor === 'company') {
                setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, companyTypeFilter: filterValues?.filter.selectValue }));
              } else {
                setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, screeningStatusFilter: filterValues?.filter.selectValue }));
              }
              if (sortValues) {
                columnUpdate = columnUpdate.map((res) => {
                  return {
                    ...res,
                    sortOrder: sortValues.field === res.accessor ? sortValues.order : null,
                  };
                });
              }
              setCustomerManagementColumn(columnUpdate);
              if (sortValues) {
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.field, sortOrder: sortValues.order, companyTypeFilter: filterValues?.filter.selectValue }));
              } else {
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, companyTypeFilter: filterValues?.filter.selectValue }));
              }
            }}
            showCheckBox={clientPermission.addAccess}
            onChangeCheckBox={handleOnChangeCheckBox}
          />
        </Stack>
        {
          <Stack
            sx={{ width: '100%' }}
            className="relative pl-[16px]   inputFormStyle"
          >
            <Box className="flex  justify-end items-center h-[56px] w-[100%] p-[5px]">
              <TablePagination
                sx={{ borderBottom: 0 }}
                rowsPerPageOptions={[]}
                count={payload.totalLength ? payload.totalLength : 0}
                rowsPerPage={payload.limit ? payload.limit : 10}
                page={payload.paginationPage ? payload.paginationPage : 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Box>
          </Stack>
        }
      </Stack>
      <Stack>
        {isDrawerOpen &&  <TraderClientDetails
          permission={clientPermission}
          isDrawerOpen={isDrawerOpen}
          toggleDrawer={() => {
            if (selectedData) {
              handleToggleDrawer();
            }
          }}
          company={selectedData}
          init={() => handleGetCompany()}
        />}
       
      </Stack>
      {openSendReport && (
        <SendReport
          compnayIds={selectedCompanyIds}
          modelOpen={openSendReport}
          onModelHandleClose={(success) => {
            if (success) {
              setSelectedCompanyIds([]);
              setOpenSendReport(false);
            }
            setOpenSendReport(false);
          }}
        />
      )}
    </Stack>: <AccessDenied />
  );
}
